﻿import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from '../shared/config/config';

declare var config: Config;


@Injectable()
export class HomeService {


    /**
     * Get the api url endpoint
     */
    protected get endpoint(): string {
        return config.apiUrl;
    };


    constructor(private http: HttpClient) { }

    public lorem = () => {
        return this.http.get<string>(this.endpoint + '/dummy/lorem')
            .toPromise();
    }
}